import { notifications } from '@mantine/notifications';
import { isAxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

export function useAppNotification() {
  const { t } = useTranslation();

  const error = (err: Error) => {
    let errorCode: string | null = null;
    if (isAxiosError(err)) {
      errorCode = err?.response?.data?.type ?? err?.response?.data?.message;
    }

    notifications.show({
      color: 'red',
      title: t('notification.error.title'),
      // An unlisted code would otherwise render its own key at the user.
      message: errorCode
        ? t(`notification.error.code.${errorCode}`, { defaultValue: t('notification.error.content') })
        : t('notification.error.content'),
    });
  };

  const success = () => {
    notifications.show({
      color: 'green',
      title: t('notification.success.title'),
      message: t('notification.success.content'),
    });
  };

  return {
    error,
    success,
  };
}
